import ComingSoon from "../Components/ComingSoon";


const BlogPage = () => {
  return (
    <ComingSoon showMinnect={true} />
  )
};

export default BlogPage;
